module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_2.d2ddbbf1.png";